import React from 'react'

import { StatusMessage } from '@pb/components'
import { useSelector } from 'react-redux'

import appSelectors from 'App/duck/selectors'
import selectors from 'features/vouchers/duck/selectors'
import { ApiError } from 'types'

export interface DiscountErrorProps {
  className?: string
}

const DiscountError: React.FC<DiscountErrorProps> = ({ className }) => {
  // TODO: what is the reason for this selector logic?
  const isDecoupledCheckoutEnabled = useSelector(
    appSelectors.getIsDecoupledCheckoutEnabled || appSelectors.getIsAbTestVoucherModalEnabled,
  )
  const errors = useSelector(selectors.getErrors)

  const discountErrors = errors.filter(
    (error) => error.target === 'couponCode' && error.isTechnicalError,
  )

  if (discountErrors.length > 0 && isDecoupledCheckoutEnabled) {
    return (
      <>
        {discountErrors.map(
          (discountError: ApiError): React.ReactElement => (
            <StatusMessage
              type="invalid"
              icon="warning"
              iconPosition="start"
              message={discountError.message}
              className={className}
            />
          ),
        )}
      </>
    )
  }

  return null
}

export default DiscountError
